/* eslint-disable  @typescript-eslint/no-explicit-any */
import { IGetUserResponse } from '~/src/repositories/User/models/User'

export function convertUser(data: any): IGetUserResponse {
  const items = data.items.map((user: any) => ({
    id: user.id ?? 0,
    name: user?.name ?? '',
    phoneNumber: user?.tel ?? '',
    countryId: user?.country?.id ?? null,
    country: user?.country?.name ?? '',
    companyName: user?.companyName ?? '',
    customerCode: user?.customerCode ?? '',
    email: user?.email ?? '',
    registerStatus: user?.isSigned,
    loadingPortId: user?.loadingPort?.id ?? null,
    loadingPort: user?.loadingPort?.name ?? '',
    createdAt: user?.createdAt ?? 0,
  }))

  return {
    users: items,
    pagination: data.pagination,
  }
}
